import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import 'rxjs/add/operator/map';
import { MarginSummaryResponse, UserBookFilters } from 'sharedweb/app.interface';
import { applicationUrls } from 'sharedweb/helpers/urls';

@Injectable({
    providedIn: 'root'
})
export class MarginSummaryService {

    private _cachedMarginSummary: MarginSummaryResponse[];

    constructor(
        private _httpClient: HttpClient
    ) {
    }

    getMarginSummaryData(marginSummaryRequest: UserBookFilters) {

        const request = { ...marginSummaryRequest, single_product: false }; //single_product is false to get all products
        const url = applicationUrls.getMarginSummaryUrl;
        return this._httpClient.get<MarginSummaryResponse[]>(url, {
            params: <any>request
        }).map(data => {
            this._cachedMarginSummary = [];
            // Sort margin summary data - "ALL" product goes first, others after
            data.forEach(item => {
                if(item.product_id === "ALL") {
                    // Add "ALL" product to beginning of array
                    this._cachedMarginSummary.unshift(item);
                }
                else {
                    // Add other products to end of array
                    this._cachedMarginSummary.push(item);
                }
            });
            return this._cachedMarginSummary;
        });
    }
}

